
import React, { forwardRef } from 'react';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

/* eslint-disable react/display-name */
export const TableIcons = {
  DetailPanel: forwardRef(
    (props, ref) => (
      <CalendarTodayIcon
        {...props}
        ref={ref}
        data-cy='savedQuery-table-icon-schedule'
      />
    )
  )
};
/* eslint-enable react/display-name */
